export default __webpack_public_path__ + "static/img_interviewee_hcho-e4b4e2e85aeca819a66708854b14673e.png";